import React from 'react';
import PropTypes from 'prop-types';

const CircleCheckMarkIcon = ({ stroke = '#FFF' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <g fill="none" fillRule="evenodd">
            <g stroke={stroke} strokeLinecap="square" strokeWidth="2" transform="translate(9 9)">
                <polyline points="5 11 9 15 17 7" />
                <circle cx="11" cy="11" r="11" />
            </g>
        </g>
    </svg>
);

CircleCheckMarkIcon.propTypes = {
    stroke: PropTypes.string,
};

export default CircleCheckMarkIcon;
